import { THEME_COLORS } from '../../theme/ThemeConstants';
import { LAYOUT_CONSTANTS, Z_INDEX } from '../layout/LayoutConstants';

interface SidebarStyleOptions {
  isMobile: boolean;
  isOpen: boolean;
}

export const useSidebarStyle = ({ isMobile, isOpen }: SidebarStyleOptions): React.CSSProperties => {
  if (isMobile) {
    return {
      position: 'fixed',
      top: 0,
      left: 0,
      width: LAYOUT_CONSTANTS.MOBILE_SIDEBAR_WIDTH,
      height: '100vh',
      backgroundColor: 'rgba(20, 20, 20, 0.9)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      padding: 16,
      paddingTop: LAYOUT_CONSTANTS.MOBILE_HEADER_HEIGHT + 16,
      paddingBottom: LAYOUT_CONSTANTS.MOBILE_CART_HEIGHT + 16,
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
      transition: `transform ${LAYOUT_CONSTANTS.TRANSITION_DURATION} ease-in-out`,
      zIndex: Z_INDEX.SIDEBAR,
      overflowY: 'auto',
      borderRight: '1px solid rgba(255, 255, 255, 0.06)'
    };
  }

  return {
    width: LAYOUT_CONSTANTS.DESKTOP_SIDEBAR_WIDTH,
    minWidth: 320,
    maxWidth: LAYOUT_CONSTANTS.DESKTOP_SIDEBAR_MAX_WIDTH,
    backgroundColor: 'rgba(15, 15, 15, 0.4)',
    backdropFilter: 'blur(24px)',
    WebkitBackdropFilter: 'blur(24px)',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    position: 'sticky',
    top: LAYOUT_CONSTANTS.DESKTOP_TOP_NAV_HEIGHT,
    height: `calc(100vh - ${LAYOUT_CONSTANTS.DESKTOP_TOP_NAV_HEIGHT}px)`,
    borderRight: '1px solid rgba(255, 255, 255, 0.08)'
  };
};
